// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { ITranslationTable } from '../EnumClass';

export const name: ITranslationTable = {
  /* eslint-disable max-len */
  Open: (t, data?, options?) => t('enum.issue-status.open.name', data, options),
  Rejected: (t, data?, options?) => t('enum.issue-status.rejected.name', data, options),
  Resolved: (t, data?, options?) => t('enum.issue-status.resolved.name', data, options),
  /* eslint-enable max-len */
};
